import { ListaInterventiOffertaComponent } from './../lista-interventi-offerta/lista-interventi-offerta.component';
import { InterventiStoreService } from './../_services/interventi-store.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { Intervento } from './../Models/Intervento';
import { Subscription } from 'rxjs';
import { ClassicType } from 'src/app/shared/models/ClassicType';

@Component({
  selector: 'app-page-interventi',
  templateUrl: './page-interventi.component.html'
})
export class PageInterventiComponent implements OnInit {
  @ViewChild('lista') lista: ListaInterventiOffertaComponent;
  subscriptions: Subscription = new Subscription();
  collectionSize: number = 0;
  Interventi: Intervento[] = [];
  statiIntervento: ClassicType[] = [];
  constructor(
    private InterventiStore: InterventiStoreService,
  ) {

  }

  ActiveId: string = 'Attività';
  activeIdChange() {
    localStorage.setItem('fasiActiveId', this.ActiveId);
  }
  ngOnInit() {
    this.ActiveId = localStorage.getItem('fasiActiveId');
    this.InterventiStore.getStatiIntervento();
    this.subscriptions.add(this.InterventiStore.$statiIntervento.subscribe(x => this.statiIntervento = x));
  }


}
